// ============================================================
// src/shack/shackConfig.js — Configuración del Shack 3D
// ============================================================

export const T = () => window.THREE;

export const MAPA_YAESU_URL = '/assets/mapa-yaesu.jpg';

export const FRAME_MODEL_PATHS = {
  black: '/assets/frames/frame_black.png',
  madera: '/assets/frames/frame_madera.png',
};

// Geometría del marco — única fuente de verdad.
// certRect: rect interior exacto donde el certificado termina en el borde dorado.
// Medido por análisis de píxeles sobre frame_black.png (1198×854).
export const FRAME_GEOMETRY = {
  certRect: { x: 0.136, y: 0.183, w: 0.730, h: 0.636 },
};

export const CAMARA = {
  fov: 49.5,
  near: 0.05,
  far: 50,
  pos:    { x: -2.18, y: 1.66, z: 2.78 },
  lookAt: { x: -1.06, y: 1.60, z: 0.05 },
  imgW: 1536,
  imgH: 864,
  ppOffsetX: 0,
  ppOffsetY: 0,
};

export const IMAGE_RATIO = CAMARA.imgW / CAMARA.imgH;

export const NORMAL_IMAGE = {
  w: 1040,
  h: Math.round(1040 / IMAGE_RATIO),
};

// Resolución de exportación del preview público (QRZ, etc.) — independiente
// del tamaño del stage del editor en pantalla (NORMAL_IMAGE).
export const PREVIEW_EXPORT = {
  w: 1920,
  h: Math.round(1920 / IMAGE_RATIO),
};

export const NORMAL_PADDING = { x: 20, y: 16 };
export const CALIB_PADDING = { x: 220, y: 150 };

export const STAGE = {
  bg: '#050505',
};

export const ROOM = {
  alto: 2.75,

  trasera: {
    ancho: 2.82,
    pos: { x: -1.41, y: 1.375, z: 0.00 },
    rotY: 0,
  },

  lateral: {
    ancho: 1.52,
    pos: { x: 0.00, y: 1.375, z: 0.76 },
    rotY: -Math.PI / 2,
  },
};

export const DEFAULT_RATIO = 1.5;
export const MIN_W = 0.14;
export const MAX_W = 0.95;
export const MIN_TONE = 0.0;
export const MAX_TONE = 1.0;

export const GRID_RES = {
  trasera: { cols: 72, rows: 52 },
  lateral: { cols: 56, rows: 44 },
};

export const CAL_STORAGE_KEY = 'cx4dpg_shack_grid_cal_16x9_v4';